/**
 * SWR (stale-while-revalidate) кеш для API панелей.
 * A4 модернизации UX: панели открываются мгновенно из кеша,
 * данные обновляются в фоне; дедупликация параллельных запросов.
 *
 * API:
 *   window.swrFetch(key, url, options?, {maxAgeMs, onRefresh}) -> Promise<{data, fromCache}>
 *   window.swrPeek(key)     -> данные из кеша или null (без запроса)
 *   window.swrInvalidate(key) -> сбросить кеш ключа (после мутаций)
 */
(function () {
  'use strict';

  var store = Object.create(null);    // key -> { data, ts }
  var inflight = Object.create(null); // key -> Promise

  function dedupe(key, fn) {
    if (!inflight[key]) {
      inflight[key] = fn().then(
        function (v) { delete inflight[key]; return v; },
        function (e) { delete inflight[key]; throw e; }
      );
    }
    return inflight[key];
  }

  function fetchJson(key, url, options) {
    return function () {
      return fetch(url, options).then(function (res) {
        if (!res.ok) {
          var err = new Error('HTTP ' + res.status);
          err.status = res.status;
          throw err;
        }
        return res.json().then(function (data) {
          store[key] = { data: data, ts: Date.now() };
          return data;
        });
      });
    };
  }

  window.swrFetch = function (key, url, options, opts) {
    options = options || {};
    opts = opts || {};
    var maxAge = typeof opts.maxAgeMs === 'number' ? opts.maxAgeMs : 60000;
    var entry = store[key];

    // Свежий кеш — отдаём сразу, сеть не трогаем
    if (entry && (Date.now() - entry.ts) <= maxAge) {
      return Promise.resolve({ data: entry.data, fromCache: true });
    }

    // Протухший кеш — показываем сразу, обновляем в фоне (один общий запрос)
    if (entry) {
      dedupe(key, fetchJson(key, url, options)).then(
        function (data) { if (typeof opts.onRefresh === 'function') opts.onRefresh(data); },
        function () { /* сеть недоступна — остаётся старое */ }
      );
      return Promise.resolve({ data: entry.data, fromCache: true });
    }

    // Кеша нет вообще — грузим с дедупликацией
    return dedupe(key, fetchJson(key, url, options)).then(function (data) {
      return { data: data, fromCache: false };
    });
  };

  window.swrPeek = function (key) {
    var e = store[key];
    return e ? e.data : null;
  };

  window.swrInvalidate = function (key) {
    delete store[key];
  };

  // Прогрев кеша без колбэков (для idle-prefetch); ошибки глушатся
  window.swrWarm = function (key, url, options) {
    if (store[key]) return Promise.resolve(store[key].data);
    return dedupe(key, fetchJson(key, url, options)).catch(function () { return null; });
  };
})();
